import appConstants from "../../../../../appConstants";
import { DateTimeEditor } from '@dataGrid/components/cellEditors';
import { setTimeFromDateTime }  from '@dataGrid/gridUtilities';

class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.DriverPreferences,
      keyColumn: "driverId",
      enableFilters: false,
      defaultColDef: {
        sortable: false,
        resizable: false,
      },
      columns: [
          {
            headerName: "Driver ID",
            field: "driverId",
            hide: true,
            headerTooltip: "Driver ID",
            minWidth: appConstants.columnWidth.DP_DRIVERID
          },
          {
            headerName: "Driver",
            field: "driverName",
            hide: true,
            headerTooltip: "Driver Name",
            minWidth: appConstants.columnWidth.DP_DRIVERNAME
          },
          {
            headerName: "Start Time",
            field: "startTime",
            headerTooltip: "Start Time",
            minWidth: appConstants.columnWidth.DP_STARTTIME,
            editable: true,
            cellEditorPopup: true,
            valueSetter: setTimeFromDateTime,
            cellEditor: DateTimeEditor,
            cellEditorParams:{
              DATETYPE: appConstants.DATETYPES.TIME
            }
          },
          {
            headerName: "Preferred Zone",
            field: "preferredZone",
            headerTooltip: "Preferred Zone",
            minWidth: appConstants.columnWidth.DP_ZONE
          },
       ]
    }
  }
}

export default GridConfig;
